// extracted by mini-css-extract-plugin
module.exports = {"siteTitle":"header-module--site-title--3fsMY","product":"header-module--product--iS-tk","skills":"header-module--skills--3R8Y-"};